import React from "react";
import type { UserWithEmail } from "lens-platform-sdk";
import Avatar from "src/components/Avatar/Avatar";
import styles from "./IDSelectItem.module.css";
import { useLensPlatformClient } from "../../hooks/useLensPlatformClient";
import { getUserAvatar } from "../../utils/user";

interface Props {
  /** The data of item passed from parent <Select /> */
  item?: {
    id: string;
    label: string;
  };
  profile?: UserWithEmail;
}

/**
 * id to be used in the select options
 */
const usernameOptionId = "usernameOptionId";

/**
 * The item component to be used in `<IDSelect />`
 */
const IDSelectItem: React.FC<Props> = ({
  item, profile
}) => {
  const id = item?.id;
  const title = item?.label ?? "";
  const platformClient = useLensPlatformClient();
  const avatarImage = profile ? getUserAvatar(profile) : undefined;
  // the item is a "Lens Business ID"
  let subTitle = "Lens Business ID";
  let avatarName = title;

  // the item is username
  if (id === usernameOptionId && profile) {
    subTitle = platformClient.user.getUserFullName(profile);
    avatarName = profile.username || "";
  }

  // As avatar image URL always stays the same for the user, e.g /:userId/avatar.jpg
  // Add a random to avatar URL to force the change of newly uploaded image.
  const avatar = avatarImage && (id === usernameOptionId) ? `${avatarImage}?${Math.random() * 1000}` : undefined;

  return (
    <>
      <Avatar image={avatar} name={avatarName} className={styles.avatar} />
      <div className={styles.label}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>{subTitle}</div>
      </div>
    </>
  );
};

export default IDSelectItem;
